import { render, staticRenderFns } from "./AdminSettingsPage.vue?vue&type=template&id=293f9c08"
import script from "./AdminSettingsPage.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettingsPage.vue?vue&type=style&index=0&id=293f9c08&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports